import Form from "./components/Form";

function App() {
  return (
    <div className="wrapper">
      <h2>React To Do App using Local Storage</h2>
      <div className="form-and-todo-box">
        <Form />
      </div>
    </div>
  );
}

export default App;
